import React, { useState, useEffect } from 'react'
import parse from 'html-react-parser';

function TemplateTwo(props) {

  const initialState = {
    userName: "Jhon Doe",
    eventName: "Nick's Birthday",
    contentBodyText: "Share your experience with your friends and family.",
    buttonText: "Share Your Photo",
    markupText: "Thank you for joining with us.",
    footerText: `&copy; 2021 <a href="https://thehaylo.com.au" style="color: #a7a7a7">The Haylo</a>. All Rights Reserved`
  }
  const [emailTemplateContent, setContent] = useState({ ...initialState })

  const [selectedState, setSelectedState] = useState(null)

  const selectElement = (stateName, theValue) => {
    props.setChangeState(stateName, theValue)

    setSelectedState(stateName)

  }

  useEffect(() => {
    if (props.changeStateData !== emailTemplateContent[`${selectedState}`]) {
      if (props.changeStateData != '') {
        let content = { ...emailTemplateContent, [`${selectedState}`]: props.changeStateData }
        setContent(content)
        props.copyEditedData(content)
      }
    }

    if (props.reset === true) {
      setContent({ ...initialState })
    }

  }, [props])

  return (
    <center style={{ width: '100%', backgroundColor: "#f1f1f1" }}>
      <div className="es-wrapper-color">
        <table className="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style={{ fontFamily: "QuickSand, sans-serif" }}>
          <tbody>
            <tr>
              <td className="esd-email-paddings" valign="top">
                <table cellpadding="0" cellspacing="0" className="es-content esd-header-popover" align="center">
                  <tbody>
                    <tr>
                      <td className="es-adaptive esd-stripe" esd-custom-block-id="24" align="center">
                        <table className="es-content-body" style={{ backgroundColor: "rgba(54, 75, 85, 0.8)" }} width="600" cellspacing="0" cellpadding="0" bgcolor="rgba(54, 75, 85, 0.8)" align="center">
                          <tbody>
                            <tr>
                              <td className="esd-structure es-p10" align="left">
                                <table className="es-left" cellspacing="0" cellpadding="0" align="left" width="100%">
                                  <tbody>
                                    <tr>
                                      <td className="esd-container-frame" width="100%" align="left">
                                        <table width="100%" cellspacing="0" cellpadding="0">
                                          <tbody>
                                            <tr>
                                              <td className="es-infoblock esd-block-text" align="center" style={{ padding: "2.5em" }}>
                                                <span className="subheading editable" style={{ display: 'inline-block', fontSize: '28px', textTransform: 'uppercase', letterSpacing: '2px', color: '#fff', fontWeight: "bold" }} onClick={selectElement.bind(this, 'userName', emailTemplateContent.userName)}>{parse(emailTemplateContent.userName)}</span>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table className="es-content esd-header-popover" cellspacing="0" cellpadding="0" align="center">
                  <tbody>
                    <tr>
                      <td className="esd-stripe" esd-custom-block-id="3109" align="center">
                        <table className="es-content-body" style={{ backgroundColor: "rgba(54, 75, 85, 0.8)" }} width="600" cellspacing="0" cellpadding="0" bgcolor="rgba(54, 75, 85, 0.8)" align="center">
                          <tbody>
                            <tr>
                              <td className="esd-structure es-p20t es-p20b es-p40r es-p40l" esd-general-paddings-checked="true" align="left">
                                <table width="100%" cellspacing="0" cellpadding="0">
                                  <tbody>
                                    <tr>
                                      <td className="esd-container-frame" width="520" valign="top" align="center">
                                        <table width="100%" cellspacing="0" cellpadding="0">
                                          <tbody>
                                            <tr>
                                              <td className="esd-block-text" align="left" style={{
                                                padding: '1.5em',
                                                textAlign: 'center',
                                                fontSize: '15px',
                                                lineHeight: "26px",
                                                color: "#7a7a7a"
                                              }}>
                                                <h4 className="editable" style={{ textAlign: 'center', color: '#fff', marginBottom: 'unset', textTransform: "capitalize" }} onClick={selectElement.bind(this, 'markupText', emailTemplateContent.markupText)}>{parse(emailTemplateContent.markupText)}</h4>
                                                <p className="editable" style={{ marginTop: 'unset', fontSize: '14px', color: "#fff" }} onClick={selectElement.bind(this, 'contentBodyText', emailTemplateContent.contentBodyText)}>{parse(emailTemplateContent.contentBodyText)}</p>

                                                <span style={{ display: 'block', marginBottom: "10px" }}>
                                                  <img src="https://www.eatright.org/-/media/eatrightimages/health/lifestyle/holidays/healthybirthday.jpg" className="attach-image" width="500" alt="template" />
                                                </span>

                                                <span className="subheading editable" style={{ display: 'inline-block', fontSize: '24px', textTransform: 'uppercase', letterSpacing: '2px', color: "#fff" }} onClick={selectElement.bind(this, 'eventName', emailTemplateContent.eventName)}>{parse(emailTemplateContent.eventName)}</span>
                                                <h2 style={{ fontSize: '18px', color: '#ffffff', fontWeight: 'light', textTransform: "uppercase" }}>21-09-2021 18:00</h2>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td className="esd-block-button es-p20t es-p20b" align="center">
                                                <a className="editable" href="#" style={{
                                                  background: '#f3a333',
                                                  color: '#ffffff', padding: '10px 20px', display: 'inline-block',
                                                  marginBottom: '40px', textDecoration: 'none', fontWeight: "bold"
                                                }} onClick={selectElement.bind(this, 'buttonText', emailTemplateContent.buttonText)}>{parse(emailTemplateContent.buttonText)}</a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td className="esd-structure es-p20t es-p20b es-p40r es-p40l" esd-general-paddings-checked="true" align="left">
                                <table width="100%" cellspacing="0" cellpadding="0">
                                  <tbody>
                                    <tr>
                                      <td className="esd-container-frame" width="520" valign="top" align="center">
                                        <table width="100%" cellspacing="0" cellpadding="0">
                                          <tbody>
                                            <tr>
                                              <td className="esd-block-spacer es-p20t es-p20b es-p5r" align="center" style={{ fontSize: "0" }}>
                                                <table width="100%" height="100%" cellspacing="0" cellpadding="0" border="0">
                                                  <tbody>
                                                    <tr>
                                                      <td style={{ borderBottom: '1px solid #8a8a8a', background: 'rgba(0, 0, 0, 0) none repeat scroll 0% 0%', height: '1px', width: '100%', margin: "0px" }}></td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>


                <table cellpadding="0" cellspacing="0" className="es-content esd-header-popover" align="center">
                  <tbody>
                    <tr>
                      <td className="es-adaptive esd-stripe" esd-custom-block-id="24" align="center">
                        <table className="es-content-body" style={{ backgroundColor: "rgba(54, 75, 85, 0.8)" }} width="600" cellspacing="0" cellpadding="0" bgcolor="rgba(54, 75, 85, 0.8)" align="center">
                          <tbody>
                            <tr>
                              <td className="esd-structure es-p10" align="left">
                                <table className="es-left" cellspacing="0" cellpadding="0" align="left" width="100%">
                                  <tbody>
                                    <tr>
                                      <td className="esd-container-frame" width="100%" align="left">
                                        <table width="100%" cellspacing="0" cellpadding="0">
                                          <tbody>
                                            <tr>
                                              <td className="es-infoblock esd-block-text" align="center" style={{ padding: '2.5em', textAlign: "center" }}>
                                                <p className="editable" style={{ color: "#fff" }} onClick={selectElement.bind(this, 'footerText', emailTemplateContent.footerText)}>{parse(emailTemplateContent.footerText)}</p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </center>

  )
}

export default TemplateTwo
